<template>
    <div>
        <st-button
            variant="secondary"
            :callback="addComplainType"
        >
            <i class="fa fa-plus"></i>
            {{ $t('COMPLAIN_TYPE.ADD_BUTTON') }}
        </st-button>
    </div>
</template>

<script>
    export default {
        name: 'ComplainTypeListToolbar',
        methods: {
            addComplainType() {
                this.$emit('addComplainType');
            },
        }
    };
</script>

